'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.manuallyReportError = exports.setRollbarUser = undefined;

var _processError = require('./processError');

var _processError2 = _interopRequireDefault(_processError);

var _addUserId = require('./addUserId');

var _addUserId2 = _interopRequireDefault(_addUserId);

var _rollbarConstants = require('./rollbarConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setRollbarUser = exports.setRollbarUser = function setRollbarUser(user) {
    if (!window.Rollbar) return;

    window.Rollbar.configure({
        payload: {
            person: {
                id: user._id,
                email: user.email
            }
        }
    });
};

// Constants
// Utils
var manuallyReportError = exports.manuallyReportError = function manuallyReportError(_ref) {
    var errorMessage = _ref.errorMessage,
        error = _ref.error,
        sensitive = _ref.sensitive,
        _ref$level = _ref.level,
        level = _ref$level === undefined ? _rollbarConstants.ROLLBAR_LEVELS.ERROR : _ref$level,
        getState = _ref.getState;

    if (!window.Rollbar) return;

    var levelFn = !!window.Rollbar[level] ? level : _rollbarConstants.ROLLBAR_LEVELS.ERROR;

    var processedError = (0, _processError2.default)({ error: error, sensitive: sensitive });
    processedError = (0, _addUserId2.default)(processedError, getState);

    window.Rollbar[levelFn](errorMessage, error, processedError);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/analytics/rollbarService.js
// module id = 226
// module chunks = 0